import axiosInstance from "../../config/axios-config";
import i18n from "../../i18n/i18n";

export const getDistributorTopData = async ({tenantId}) => {
    const currentLanguage = i18n.language;
    let response;
    try {
        response = await axiosInstance.get("/api/v1/product_tenants/discounted/table", {
            params: {
              tenantId: tenantId
            },
            headers: {
                "Language-Context": currentLanguage.toUpperCase(),
            },
        });
    } catch (err) {
        console.error("Error fetching data:", err);
    }
    return response.data;
};